module.exports = "<header-mov></header-mov>\n<div class=\"principal\" fxLayout=\"row\">\n    <summary-mov fxFlex=\"80%\"></summary-mov>\n</div>"